export default __webpack_public_path__ + "static/media/plugging.e4fa19c9.png";